import AssetType from './setting/AssetType.jsx';
import AssetMaker from './setting/AssetMaker.jsx';
import AssetMakerSupport from './setting/AssetMakerSupport.jsx';
import Declaration from './setting/Declaration.jsx';


const SettingTab = () => {
   
    return (
        <div>

            <div className="content-block">

                <AssetType />
                <AssetMaker />
                <AssetMakerSupport />
                <Declaration />

            </div>
        </div>
    );
}

export default SettingTab;